// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { QuestRoute } from './api/QuestRoutes';
import { Regex } from './api/regex';
import Form from './form/Form';
import Input from './form/Input';
import { useGlobalState } from './globalState/GlobalStateProvider';
import Modal from './Modal';
import { HamQuest } from '../../App';

const UpdatePassword = ({ ...props }) => {
    const {
        state: {
            active_user,
        },
        logIn,
    } = useGlobalState();

    const { search } = useLocation();
    const query = new URLSearchParams(search)
    const navigate = useNavigate();

    return query.get('token') ?
        (
            <Form
                inputs={{
                    email: query.get('email') || '',
                    token: decodeURIComponent(query.get('token')) || '',
                    password: '',
                    confirmPassword: '',
                }}
                onSubmit={(e) => HamQuest
                    .post(QuestRoute.user.recoverPassword, {
                        ...e,
                    })
                    .then(() => {
                        Modal.Show({
                            title: 'Success',
                            body: 'Password updated!',
                            type: 'success',
                        })
                        logIn({
                            email: e.email,
                            password: e.password
                        })
                            .then(() => navigate('/'))
                    })
                    .catch(ex => {
                        Modal.Show({
                            type: 'error',
                            title: 'Failed to update Password',
                            body: ex.blob || 'Something went wrong. Please try again.'
                        })
                    })
                }
                submitButton='Update Password'
                submittingButton='Updating Password'
            >
                <Input
                    label='New Password'
                    name='password'
                    type='password'
                    validate={Regex.test.password}
                    required
                />
                <Input
                    label='Confirm New Password'
                    name='confirmPassword'
                    type='password'
                    confirmation='password'
                    required
                />
            </Form>
        ) : (
            <Form
                inputs={{
                    password: '',
                    newPassword: '',
                    newConfirmedPassword: ''
                }}
                onSubmit={(e) => HamQuest
                    .post(QuestRoute.user.updatePassword, {
                        currentPassword: e.password,
                        newPassword: e.newPassword
                    })
                    .then(res => {
                        Modal.Show({
                            title: 'Success',
                            body: 'Password updated!',
                            type: 'success',
                        })
                    })
                    .catch(ex => {
                        Modal.Show({
                            type: 'error',
                            title: 'Error updating Password',
                            body: ex.blob || 'Something went wrong. Please try again.'
                        })
                    })
                }
                submitButton={`Update Password`}
            >
                <Input
                    label='Password'
                    name='password'
                    type='password'
                    required
                />
                <Input
                    label='New Password'
                    name='newPassword'
                    type='password'
                    validate={Regex.test.password}
                    required
                />
                <Input
                    label='Confirm New Password'
                    name='newConfirmedPassword'
                    type='password'
                    confirmation='newPassword'
                    required
                />
            </Form>
        );
}

export default UpdatePassword;